import { formatAnyDate } from '@helpers/dateUtils';
import {
  SET_ALL_DOCUMENT_TYPES_DATA,
  SET_FILTER_FIND_UPLOAD_DOCUMENT_HISTORY_CONFIG,
  SET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA,
} from './constants';

export const initialState = {
  findUploadDocumentHistoryData: [],
  filterFindUploadDocumentHistoryConfig: {
    uploadDocumentTypeCode: '',
    policyId: '',
    fileName: '',
    fromUploadDate: formatAnyDate(Date.now()),
    toUploadDate: formatAnyDate(Date.now()),
    page: 0,
    size: 10,
  },
  allDocumentTypes: [],
};

const contractReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA:
      state = {
        ...state,
        findUploadDocumentHistoryData: payload,
      };
      break;
    case SET_FILTER_FIND_UPLOAD_DOCUMENT_HISTORY_CONFIG:
      state = {
        ...state,
        filterFindUploadDocumentHistoryConfig: payload,
      };
      break;
    case SET_ALL_DOCUMENT_TYPES_DATA:
      state = {
        ...state,
        allDocumentTypes: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default contractReducers;
